namespace $ { $mol_style_attach( "gen/app/app.view.css",
 "/* [mol_page] {\n\tflex-basis: 10rem;\n}\n\n[gen_app_dev_page] {\n\tflex-basis: 50rem;\n} */"
) }